import { render, staticRenderFns } from "./importFlexfieldDialog.vue?vue&type=template&id=6738eed2&lang=pug"
import script from "./importFlexfieldDialog.vue?vue&type=script&lang=js"
export * from "./importFlexfieldDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports